import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0A0A0A]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <img
          src="https://static.readdy.ai/image/83c8b6e061a44e022865ce6b25288245/bd6a12f5d4c632fae95447266d8cc718.png"
          alt="FlexForce logo"
          className="h-10 w-auto object-contain cursor-pointer"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        />

        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'Problème', id: 'probleme' },
            { label: 'Solution', id: 'solution' },
            { label: 'Avantages', id: 'avantages' },
            { label: 'Processus', id: 'processus' },
            { label: 'Témoignages', id: 'temoignages' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white/80 hover:text-[#6ECFA0] text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('cta-final')}
            className="bg-[#6ECFA0] text-black font-bold text-sm px-5 py-2.5 rounded-full hover:bg-[#8DDAB5] transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Devis gratuit
          </button>
        </div>

        <button
          className="md:hidden text-white cursor-pointer w-8 h-8 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#0A0A0A] border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {[
            { label: 'Problème', id: 'probleme' },
            { label: 'Solution', id: 'solution' },
            { label: 'Avantages', id: 'avantages' },
            { label: 'Processus', id: 'processus' },
            { label: 'Témoignages', id: 'temoignages' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white/80 hover:text-[#6ECFA0] text-sm font-medium transition-colors duration-200 text-left cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('cta-final')}
            className="bg-[#6ECFA0] text-black font-bold text-sm px-5 py-2.5 rounded-full hover:bg-[#8DDAB5] transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
          >
            Devis gratuit
          </button>
        </div>
      )}
    </nav>
  );
}
